import React from 'react'
import styled from '@emotion/styled'
import { Box, Divider, Paper } from '@mui/material'
import { customStyles, spaceBetween } from '../../../styles'
import { MainButton, SmallText } from '../../helpers'
import ChevronRightOutlinedIcon from '@mui/icons-material/ChevronRightOutlined';
export const HelpThisOrder = () => {
  const CustomBox = styled(Box)(() => ({
    ...spaceBetween,
    height: 60,
    padding: 10,
    borderBottom: `1px solid ${ customStyles.colors.lightColor }`,
  }))
  return (
    <Paper sx={{ padding: 0, overflow: 'hidden' }}>
      <CustomBox>
        <SmallText text="Mi pedido llegó incompleto"/>
        <ChevronRightOutlinedIcon />
      </CustomBox>
      <CustomBox>
        <SmallText text="Mi pedido llegó incompleto"/>
        <ChevronRightOutlinedIcon />
      </CustomBox>
      <CustomBox>
        <SmallText text="Mi pedido llegó incompleto"/>
        <ChevronRightOutlinedIcon />
      </CustomBox>
      <CustomBox sx={{ border: 'none' }}>
        <MainButton text="Ver mas soluciones" variant="outlined" size={ customStyles.buttonSize.full }/>
      </CustomBox>
    </Paper>
  )
}
